<template>
  <div ref="body" style="position: relative; padding-bottom: 70px;" @mouseenter="divMouseenter">
    <div v-if="zoneId" class="tools">
      <vs-button class="py-0 px-3" type="border" color="secondary" style="background-color: #fff;" @click="onClick({id: 0, name: 0})">
        <div class="flex items-center" style="margin-top: 4px">
          <feather-icon icon="ChevronLeftIcon" style="width: 18px;"/>
          전체보기
        </div>
      </vs-button>
    </div>
    <div
      ref="tooltip"
      style="position: absolute; z-index: 1000; padding: 5px 10px; background-color: #fff; border: solid 2px #000; font-size: 14px; pointer-events: none; display: none;"
      ></div>

    <img
      ref="mapImage"
      :src="require('@/assets/images/도면/도면_당진공장.png')"
      alt=""
      usemap="#map1"
      class="w-full opacity-50"
      @load="updateCoords"
    />
    <svg
      viewBox="0 0 3454 1475"
      style="position: absolute; top: 0; left: 0; pointer-events: none;"
    >
      <template v-for="origin in original">
        <!-- 기존 polygon은 그대로 유지 -->
        <polygon v-if="origin.shape === 'poly'" :id="origin.id" fill="rgba(0, 0, 255, 0.3)" stroke="blue" :points="origin.coords" stroke-width="8" style="display: none" :key="`polygon_${origin.id}`"/>

        <!-- 중점대상일 때 삼각형 마커 -->
        <template v-if="origin.center && origin.isCritical && origin.edge > 0">
          <!-- 삼각형 그림자 -->
          <polygon
            :id="`${origin.id}_shadow`"
            :points="`${origin.center.x + 3},${origin.center.y - 48 + 3} ${origin.center.x - 48 + 3},${origin.center.y + 48 + 3} ${origin.center.x + 48 + 3},${origin.center.y + 48 + 3}`"
            fill="rgba(0,0,0,0.3)"
            :key="`triangle_shadow_${origin.id}`"
          />

          <!-- 삼각형 배경 -->
          <polygon
            :id="`${origin.id}_triangle`"
            :points="`${origin.center.x},${origin.center.y - 48} ${origin.center.x - 48},${origin.center.y + 48} ${origin.center.x + 48},${origin.center.y + 48}`"
            fill="#FF6B6B"
            stroke="#FF4757"
            stroke-width="2"
            :key="`triangle_${origin.id}`"
          />

          <!-- 삼각형 내부 텍스트 -->
          <text
            :id="`${origin.id}_text`"
            :x="origin.center.x"
            :y="origin.center.y + 12"
            fill="#fff"
            font-size="48px"
            text-anchor="middle"
            font-weight="600"
            alignment-baseline="middle"
            :key="`triangle_text_${origin.id}`"
          >
            {{ origin.edge }}
          </text>
        </template>

        <!-- 일반일 때 원형 마커 -->
        <template v-else-if="origin.center">
          <!-- 마커 배경 - 그림자 추가 -->
          <circle
            :id="`${origin.id}_shadow`"
            :cx="origin.center.x + 3"
            :cy="origin.center.y + 3"
            :r="origin.edge > 0 ? 54 : 32"
            fill="rgba(0,0,0,0.3)"
            :key="`shadow_${origin.id}`"
          />

          <!-- 마커 배경 -->
          <circle
            :id="`${origin.id}_circle`"
            :cx="origin.center.x"
            :cy="origin.center.y"
            :r="origin.edge > 0 ? 54 : 32"
            :fill="origin.edge > 0 ? 'rgba(220, 53, 69, 0.9)' : 'rgba(255, 255, 255, 0.9)'"
            :stroke="origin.edge > 0 ? '#c82333' : '#dee2e6'"
            stroke-width="2"
            :key="`circle_${origin.id}`"
          />

          <!-- 마커 내부 텍스트 -->
          <text
            :id="`${origin.id}_text`"
            :x="origin.center.x"
            :y="origin.center.y"
            :fill="origin.edge > 0 ? '#fff' : '#495057'"
            :font-size="origin.edge > 0 ? '48px' : '28px'"
            text-anchor="middle"
            font-weight="600"
            alignment-baseline="middle"
            :key="`text_${origin.id}`"
          >
            {{ origin.edge }}
          </text>
        </template>
      </template>

      <!-- 선택된 마커 스타일도 동일하게 수정 -->
      <template v-if="selectZone && selectZone.center">
        <polygon v-if="selectZone" id="currentZone" fill="rgba(0, 0, 255, 0.3)" stroke="blue" :points="selectZone.coords" stroke-width="8"/>

        <!-- 선택된 마커 그림자 -->
        <circle
          id="currentZone_shadow"
          :cx="selectZone.center.x + 3"
          :cy="selectZone.center.y + 3"
          r="28"
          fill="rgba(0,0,0,0.3)"
        />

        <!-- 선택된 마커 배경 -->
        <circle
          id="currentZone_circle"
          :cx="selectZone.center.x"
          :cy="selectZone.center.y"
          r="28"
          fill="rgba(220, 53, 69, 0.9)"
          stroke="#c82333"
          stroke-width="2"
        />

        <!-- 선택된 마커 텍스트 -->
        <text
          id="currentZone_text"
          :x="selectZone.center.x"
          :y="selectZone.center.y"
          fill="#fff"
          font-size="24px"
          text-anchor="middle"
          font-weight="600"
          alignment-baseline="middle"
        >
          {{ selectZone.edge }}
        </text>
      </template>
    </svg>

    <map name="map1">
      <area
        v-for="(s, index) in scaled"
        :key="index"
        :shape="s.shape"
        :coords="s.coords"
        href="#"
        @mouseover="showPolygon(s)"
        @mouseout="hidePolygon(s)"
        @click="onClick(s)"
      />
    </map>

    <!-- 범례 -->
    <div class="tools" style="top:auto; bottom: 10px; left: 50%; transform: translateX(-50%)">
      <div class="grid" style="grid-template-columns: auto auto; border: 1px solid #999999;">
        <span class="px-1" style="width: 8px; background-color: #999999; color:#fff;"></span>
        <div class="flex gap-4 p-2 font-bold">
          <div class="flex items-center gap-1">
            <div class="grid place-items-center rounded-full" style="width:32px; height: 32px; background-color: rgba(220, 53, 69, 0.9); color: #fff; font-size: 16px; font-weight: 600;"></div>
            일반작업
          </div>
          <div class="flex items-center gap-1">
            <div class="rounded-none"
                 style="width:32px; height:32px; padding-top: 6px;
              background-color: #FF4757;
              color:#fff; font-size:16px; font-weight:600;
              display:flex; align-items:center; justify-content:center;
              clip-path: polygon(50% 0%, 0% 100%, 100% 100%);"></div>
            중점대상현황
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "MapFactoryAccess2",
  props: {
    value: [String, Number],
    markers: Array,
  },
  data () {
    return {
      zoneId: this.value,
      selectZone: null,
      width: 3454,
      height: 1475,
      original: [
        /** 지도의 zone 과 통일성을 위해 id 와 label 은 DB에 저장된 값을 사용한다 */
        { id: "1", label: "154KV", edge: "0", shape: "poly", coords: "4,561,162,561,162,775,4,775" },
        { id: "2", label: "중앙창고", edge: "0", shape: "poly", coords: "3,858,162,858,162,1073,3,1073" },
        { id: "3", label: "제품창고", edge: "0", shape: "poly", coords: "343,609,756,609,756,1381,343,1381" },
        { id: "4", label: "협폭단척", edge: "0", shape: "poly", coords: "756,607,912,607,912,918,756,918" },
        { id: "5", label: "정정단", edge: "0", shape: "poly", coords: "760,919,2171,919,2171,1075,760,1075" },
        { id: "6", label: "off-Line", edge: "0", shape: "poly", coords: "758,1077,2168,1077,2168,1228,758,1228" },
        { id: "7", label: "열처리로", edge: "0", shape: "poly", coords: "872,1232,1766,1232,1766,1379,872,1379" },
        { id: "8", label: "전기실 Shear No.2", edge: "0", shape: "poly", coords: "952,815,1257,815,1257,912,952,912" },
        { id: "9", label: "시험실", edge: "0", shape: "poly", coords: "1292,646,1569,646,1569,916,1292,916" },
        { id: "10", label: "전기실 Shear No.1", edge: "0", shape: "poly", coords: "1604,755,1899,755,1899,917,1604,917" },
        { id: "11", label: "C/B", edge: "0", shape: "poly", coords: "1952,647,2261,647,2261,916,1952,916" },
        { id: "12", label: "FM", edge: "0", shape: "poly", coords: "2259,879,2930,879,2930,1016,2259,1016" },
        { id: "13", label: "기계정비", edge: "0", shape: "poly", coords: "2262,1024,2468,1024,2468,1156,2262,1156" },
        { id: "14", label: "기계(수처리)", edge: "0", shape: "poly", coords: "2269,854,2447,854,2447,692,2900,694,2899,863,3008,862,3008,435,2706,435,2706,506,2272,504" },
        { id: "15", label: "전기실 Mill", edge: "0", shape: "poly", coords: "2474,1018,2930,1018,2930,1157,2474,1157" },
        { id: "16", label: "사무동", edge: "0", shape: "poly", coords: "2501,1212,2690,1212,2690,1405,2501,1405" },
        { id: "17", label: "Roll Shop", edge: "0", shape: "poly", coords: "2470,742,2876,742,2876,878,2470,878" },
        { id: "18", label: "가열로", edge: "0", shape: "poly", coords: "2930,878,3050,878,3050,1265,2930,1265" },
        { id: "19", label: "특수강", edge: "0", shape: "poly", coords: "3053,358,3417,358,3417,478,3053,478" },
        { id: "20", label: "Slab Yard", edge: "0", shape: "poly", coords: "3051,665,3416,665,3416,1285,3051,1285" },
        { id: "24", label: "기타지역", edge: "0", shape: "poly", coords: "2420,51,2789,51,2789,288,2420,288" }
      ],

      scaled: [],
    }
  },
  computed: {
    imgWidth() {
      return this.$refs.mapImage ? this.$refs.mapImage.clientWidth : 0;
    },
  },
  watch: {
    imgWidth:{
      handler() {
        this.updateCoords();
      },
      immediate: true,
    },
    markers (markers) {
      this.original.forEach((origin, i) => {
        markers.forEach((marker) => {
          if (`${origin.id}` === `${marker.id}`) {
            this.original[i].edge = marker.edge;
            this.original[i].isCritical = marker.isCritical; // 중점대상 여부 추가
          }
        });
      });
    }
  },
  mounted() {
    this.updateCoords();
    window.addEventListener("resize", this.updateCoords); // 창 크기 변경 시 좌표 갱신
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateCoords); // 이벤트 제거
  },
  methods: {
    updateCoords() {
      const img = this.$refs.mapImage;
      if (img) {
        const scaleX = img.clientWidth / this.width; // 원본 너비에 대한 스케일
        const scaleY = img.clientHeight / this.height; // 원본 높이에 대한 스케일

        // 도형의 중심을 계산하여 원 추가
        for (let i = 0; i<this.original.length; i++) {
          const coords = this.original[i];
          let center = {};
          if (coords.shape === "poly") {
            center = this.calculatePolygonCenter(coords.coords);
          } else if (coords.shape === "rect") {
            center = this.calculateRectCenter(coords.coords);
          }

          this.original[i].center = {
            x: center.x,
            y: center.y
          };
        }


        // 원본 좌표를 스케일에 맞게 변환
        this.scaled = this.original.map((coords) => {
          const coordsData = {
            id: coords.id,
            label: coords.label,
            shape: coords.shape,
            coords: coords.coords
              .split(",")
              .map((value, index) => {
                const scale = index % 2 === 0 ? scaleX : scaleY; // X 좌표와 Y 좌표에 따라 다른 스케일 적용
                return Math.round(value * scale); // 스케일링 후 반올림
              })
              .join(",")
          }
          return coordsData;
        });

      }
    },
    // 다각형의 중심을 계산하는 함수
    calculatePolygonCenter(coords) {
      const points = coords.split(",").map(Number);
      let x = 0, y = 0;
      const numPoints = points.length / 2;

      for (let i = 0; i < numPoints; i++) {
        x += points[i * 2];
        y += points[i * 2 + 1];
      }

      return {
        x: x / numPoints,
        y: y / numPoints
      };
    },

    // 사각형의 중심을 계산하는 함수
    calculateRectCenter(coords) {
      const [x1, y1, x2, y2] = coords.split(",").map(Number);
      return {
        x: (x1 + x2) / 2,
        y: (y1 + y2) / 2
      };
    },

    // 다각형 표시
    showPolygon(ss) {
      const id = ss.id
      const el = document.getElementById(id)
      if (el) {
        document.getElementById(id).style.display = 'block';
        const rectPosition = el.getBoundingClientRect();
        const parentPosition = this.$refs.body.getBoundingClientRect();
        this.$refs.tooltip.style.display = '';
        this.$refs.tooltip.style.top = `${rectPosition.top - parentPosition.top - 40}px`;
        this.$refs.tooltip.style.left = `${rectPosition.left - parentPosition.left}px`;
        this.$refs.tooltip.textContent = ss.label;
      }
    },
    hidePolygon(ss) {
      const id = ss.id
      if (document.getElementById(id)) {
        document.getElementById(id).style.display = 'none';
      }
      this.$refs.tooltip.style.display = 'none';
    },

    onClick (ss) {
      this.zoneId = ss.id;
      const find = this.original.find((item) => item.id === ss.id);
      if (find) {
        this.selectZone = find;
      } else {
        this.selectZone = null;
      }
      this.$emit("click", {id: ss.id, name: ss.label})
    },

    resetSelectZone() {
      this.selectZone = null;
    },

    divMouseenter() {
      this.updateCoords();
    }
  },
}
</script>

<style scoped>
circle.active {
  r: 54;
  fill: red;
  stroke: red;
  stroke-width: 4;
}
text.active {
  fill: #fff;
  font-size: 48px;
  font-weight: bold;
}
.tools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  background-color: #fff;
  border-radius: 6px;
}
</style>
